import React, {useContext, useEffect, useState} from "react";
import {isMentee, SessionContext} from "../../../Utils/sessions";
import {Root} from 'Root'
import EditMentorProfile from "./EditMentorProfile";
import StudentApplicantProfile from "./StudentApplicantProfile";
import Loading from "../../Landing/Loading";

const EditUserProfile = () => {
    const {session} = useContext(SessionContext)
    const [profile, setProfile] = useState(undefined)

    useEffect(() => {
        if (isMentee(session)) {
            Root.userApi.getUserProfile(session.jwt).then((res) => {
                setProfile(res.data)
            }).catch(() => {
                setProfile({})
            })
        }
    }, [session]);

    if (isMentee(session)) {
        return <>
            {profile ?
                <StudentApplicantProfile userProfile={profile} beginEditing={true} /> :
                <Loading />
            }
        </>
    } else {
        return <>
            <EditMentorProfile />
        </>
    }
}

export default (EditUserProfile);